import { createAction, props } from '@ngrx/store';
import { TsForwardSettings } from '../ts-forward-settings.model';

export const setTsForwardSettings = createAction(
  '[Ts Forward Settings] list',
  props<{ tsForwardSettings: TsForwardSettings[] }>()
);

export const addTsForwardSetting = createAction(
  '[Ts Forward Settings] add',
  props<{ tsForwardSetting: TsForwardSettings }>()
);

export const updateTsForwardSetting = createAction(
  '[Ts Forward Settings] update',
  props<{ tsForwardSetting: TsForwardSettings }>()
);

export const reorderTsForwardSettings = createAction(
  '[Ts Forward Settings] reorder',
  props<{ tsForwardSettings: TsForwardSettings[] }>()
);

export const deleteTsForwardSettings = createAction(
  '[Ts Forward Settings] delete',
  props<{ ids: string[] }>()
);

export const setTsForwardSettingsLocallyChanged = createAction(
  '[Ts Forward Settings] set locally changed',
  props<{ isLocallyChanged: boolean }>()
);

export const clearTsForwardSettings = createAction('[Ts Forward Settings] clear');
